module.exports = __webpack_public_path__ + "static/img/主视觉KV设计-插画主视觉.3c52118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/主视觉KV设计-插画主视觉.png
// module id = aTF4
// module chunks = 1